import Component from '@glimmer/component'
import { context } from 'customer-flows/utils/core'

type CustomerInfoSummaryArgs = {
  Blocks: {
    customerActions: []
  }
}

export default class CustomerInfoSummary extends Component<CustomerInfoSummaryArgs> {
  @context('customer') name: CustomerStore['name']
  @context('customer') email: CustomerStore['email']
  @context('customer') phone: CustomerStore['phone']

  <template>
    <div class='w-full mt-1 @md/flow:mt-4' data-testid='customer-info-summary' ...attributes>
      <il-card>
        <div slot='section' class='flex justify-between items-center'>
          <div>
            <div data-testid='customer-info-summary__name' class='text-component-bold-para-14 text-neutrals-300 mb-1'>
              {{this.name}}
            </div>
            <div data-testid='customer-info-summary__contact-details' class='flex flex-col gap-1'>
              <div class='text-component-reg-para-14 text-neutrals-300'>{{this.phone}}</div>
              <div class='text-component-reg-para-14 text-neutrals-300'>{{this.email}}</div>
            </div>
          </div>
          <div class='flex items-center'>
            {{yield to='customerActions'}}
          </div>
        </div>
      </il-card>
    </div>
  </template>
}
